/* ============================================================================
   Success System popup for the CART DRAWER.

   The drawer is ~440px wide and its footer is a flex item with no flex property,
   so its min-content height wins over the body's `flex: 1`. Rendering the full
   bonus list in there squeezed the cart items to 40px and pushed the checkout
   button below the viewport. The drawer now shows a single tappable row and the
   detail lives here, in a popup, so the drawer's height is fixed no matter how
   much copy Owen adds later. The cart PAGE still renders the list inline.

   ⚠️ Escape is the fiddly part. theme.js traps focus in the open drawer and its
   handler calls closeAllPanels() on Escape — which would dump the shopper out of
   the cart entirely instead of just closing this popup. So this listener runs in
   the CAPTURE phase on `document` (before theme.js's bubble-phase listener) and
   stops propagation while the popup is open. Closing the popup must return you
   to the drawer, never past it.

   ⚠️ The toggle lives inside [data-cart-drawer-inner], which theme.js replaces
   wholesale on every cart change, so nothing here may bind to it directly —
   every handler is delegated from `document`.
   ========================================================================== */

(function () {
  'use strict';

  var OPEN = 'is-open';
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),' +
                  'select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  var lastOpener = null;

  function modal() { return document.getElementById('CsysModal'); }
  function isOpen() { var m = modal(); return !!m && m.classList.contains(OPEN); }

  function open(opener) {
    var m = modal();
    if (!m) return;
    lastOpener = opener || null;

    m.hidden = false;
    /* The transition needs a rendered start state before the class lands, or the
       browser collapses both writes and nothing animates. Force a reflow rather
       than waiting on requestAnimationFrame: rAF does NOT fire in a background
       tab, which left the popup laid out but stuck at opacity 0 with aria-hidden
       still true — open, invisible, and announced as hidden. */
    void m.offsetHeight;
    m.classList.add(OPEN);
    m.setAttribute('aria-hidden', 'false');

    if (opener) opener.setAttribute('aria-expanded', 'true');

    var close = m.querySelector('.csys-modal__close');
    if (close) close.focus();
  }

  function close() {
    var m = modal();
    if (!m || !m.classList.contains(OPEN)) return;

    m.classList.remove(OPEN);
    m.setAttribute('aria-hidden', 'true');

    /* keep it in the layout until the fade finishes, then take it out of the
       tab order entirely */
    window.setTimeout(function () {
      if (!m.classList.contains(OPEN)) m.hidden = true;
    }, 220);

    if (lastOpener && document.body.contains(lastOpener)) {
      lastOpener.setAttribute('aria-expanded', 'false');
      lastOpener.focus();
    } else {
      /* the drawer re-rendered while the popup was open, so the button that
         opened it no longer exists — put focus somewhere sane inside the drawer */
      var fallback = document.querySelector('.cart-drawer.is-open [data-csys-open], .cart-drawer.is-open button');
      if (fallback) fallback.focus();
    }
    lastOpener = null;
  }

  /* --------------------------------------------------------------- events */

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-csys-open]');
    if (opener) { e.preventDefault(); open(opener); return; }

    if (e.target.closest('[data-csys-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;

    if (e.key === 'Escape') {
      /* stop theme.js from also closing the cart drawer underneath */
      e.stopPropagation();
      e.preventDefault();
      close();
      return;
    }

    if (e.key !== 'Tab') return;

    var m = modal();
    var items = Array.prototype.slice.call(m.querySelectorAll(FOCUSABLE))
      .filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;

    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    /* Tab is confined to the popup, so it must not reach theme.js's own trap */
    e.stopPropagation();
  }, true);   /* capture — must run before theme.js's document listener */

  /* If the drawer itself is closed some other way, don't leave this stranded on
     top of a closed cart. */
  document.addEventListener('click', function (e) {
    if (!isOpen()) return;
    if (e.target.closest('[data-close-panel]') || e.target.classList.contains('overlay')) close();
  }, true);
})();
